<template>
  <AnalyticsDecimalPrecisions />
</template>

<script setup lang="ts">
import AnalyticsDecimalPrecisions from './AnalyticsDecimalPrecisions.vue'

defineOptions({ name: 'AnalyticsSettings' })
</script>
